import { render } from "./EventDataGrid.vue?vue&type=template&id=f4a08cfc&scoped=true&ts=true"
import script from "./EventDataGrid.vue?vue&type=script&lang=ts"
export * from "./EventDataGrid.vue?vue&type=script&lang=ts"

import "./EventDataGrid.vue?vue&type=style&index=0&id=f4a08cfc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a08cfc"]])

export default __exports__